<template>
  <CarListLarge
      v-if="!availabilityPlan && !availabilityCheck && filter && !vehiclesList && !abo && large"
      :data="data"
      :filter="filter"
      @update:error="showError"
      @openContact="openContact"
  />
  <CarListSmall
    v-if="!availabilityPlan && !availabilityCheck && filter && !vehiclesList && !abo && !large"
    :data="data"
    :filter="filter"
    @update:error="showError"
    @openContact="openContact"
  />

  <CarListAvaiabilites
    v-if="(availabilityPlan || availabilityCheck) && filter && !vehiclesList && !abo"
    :data="data"
    :filter="filter"
    :show-availability-plan="availabilityPlan"
    :force-check="availabilityCheck"
    @update:error="showError"
    @openContact="openContact"
  />

  <CarListSearch
    v-if="filter && vehiclesList && !small && !abo"
    :data="data"
    :filter="filter"
    :stations="stations"
    :opened="opened"
    @openContact="openContact"
    @openSearchTarif="setCarOpen"
  />
  <CarListSearchSmall
    v-if="filter && vehiclesList && small && !abo"
    :data="data"
    :filter="filter"
    :stations="stations"
  />

  <CarListSearchAbo
    v-if="filter && abo && !aboV2"
    :data="data"
    :filter="filter"
    :stations="stations"
    :opened="opened"
    @openContact="openContact"
    @openSearchTarif="setCarOpen"
  />
  <CarListAboSmall
      v-if="filter && abo && aboV2"
      :data="data"
      :filter="filter"
      :stations="stations"
      :opened="opened"
      @openContact="openContact"
      @openSearchTarif="setCarOpen"
  />
</template>

<script>
import { defineComponent } from "vue";
// import store from "@/store";
import CarListSmall from "@/components/cargroup/car-list-small.vue";
import CarListAvaiabilites from "@/components/cargroup/car-list-availabilities.vue";
import CarListSearch from "@/components/cargroup/car-list-search.vue";
import CarListSearchAbo from "@/components/cargroup/car-list-abo-large.vue";
import CarListAboSmall from "@/components/cargroup/car-list-abo-small.vue";
import CarListLarge from "@/components/cargroup/car-list-large.vue";

import CarListSearchSmall from "@/components/cargroup/car-list-search-small.vue";
import i18n from "@/mixins/mixins";

export default defineComponent({
  name: "car",
  components: {
    CarListLarge,
    CarListSmall,
    CarListAvaiabilites,
    CarListSearch,
    CarListSearchSmall,
    CarListSearchAbo,
    CarListAboSmall
  },
  emits: ["openContact", "update:openedCar"],
  mixins: [i18n],
  props: {
    availabilityPlan: { type: Boolean, default: false },
    availabilityCheck: { type: Boolean, default: false },
    data: Object,
    filter: Boolean,
    vehiclesList: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    stations: { type: Object },
    opened: { type: String },
    abo: Boolean,
    aboV2: Boolean,
  },
  data() {
    return {
      error: {
        show: false,
        data: {
          header: this.i18n("error/tocarselect/header"),
          content: this.i18n("error/tocarselect/content"),
          buttonFirst: "Home",
          buttonFirstLabel: this.i18n("error/tocarselect/buttonFirstLabel"),
        },
      },
    };
  },
  methods: {
    showError() {
      // console.log(ev);
      this.error.show = true;
      //this.error.data.content = ev.form.message;
    },
    openContact(car) {
      this.$emit("openContact", car);
    },
    setCarOpen(car) {
      // console.log(car);
      this.$emit("update:openedCar", car);
    },
  },
});
</script>
